import { jsx as e } from "react/jsx-runtime";
import { skeletonCardBlueprint as s } from "./index-blueprint.es.js";
import { withZod as i } from "@made-people/react-prop-guard";
import { z as o } from "zod";
import { withManagedProps as m } from "@made-people/managed-props";
import "@made-people/blueprint";
const p = o.object({
  variants: o.custom().optional(),
  as: o.literal("product-card").optional()
}), h = m(
  "SkeletonCard",
  i(
    {
      schema: p,
      defaultProps: {
        as: "product-card"
      }
    },
    ({ variants: t, as: r }) => {
      const a = s.styles(t);
      if (r === "product-card")
        return /* @__PURE__ */ e("div", { className: a.base });
    }
  )
);
export {
  h as SkeletonCard,
  p as skeletonCardSchema
};
//# sourceMappingURL=index.es.js.map
